import React, { Suspense, lazy, Fragment } from "react";
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import { compose } from "recompose";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Slide from "@material-ui/core/Slide";
import constant from "../TrailerLayout/constant";
import { AppLoading } from "../../../../../loaders/loaders";
import { withAppConfig } from "../../../../../appConfigContext";

const ViewProImages = lazy(() =>
  import("../../../IBPlanning/Common/ViewProImages")
);

class BillDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showProImagesPopup: false,
    };
  }

  updateModalVisibility = (showProImagesPopup) => {
    if (Boolean(this.props.configJSON.proImagesUrl)) {
      this.setState({
        showProImagesPopup,
      });
    }
  };

  getBillClassForLeftBorder = (billType) => {
    const { classes } = this.props;
    switch (billType) {
      case constant.PRO_TYPE.MISSED:
        return classes.cardLeftBorderMissedBill;
      case constant.PRO_TYPE.EXTRA:
        return classes.cardLeftBorderExtraBill;
      default:
        return "";
    }
  };

  getBillClassForPlannedColor = (billType) => {
    const { classes } = this.props;
    switch (billType) {
      case constant.PRO_TYPE.MISSED:
        return classes.colorMissedBill;
      case constant.PRO_TYPE.EXTRA:
        return classes.colorExtraBill;
      default:
        return "";
    }
  };

  render() {
    const { classes, data } = this.props;

    const {
      proId,
      customerName,
      dockWorkerName,
      address,
      weight,
      pse,
      hu,
      actualArrivalTime,
      deliveryWindow,
      manifestNumber,
      billType,
      shipmentStatus,
      plannedRouteName,
      dispatchedRouteName,
      plannedFMRT,
      dispatchedFMRT,
    } = data;
    console.log(proId, billType);
    return (
      <Fragment>
        <Suspense fallback={<AppLoading />}>
          {this.state.showProImagesPopup && (
            <ViewProImages
              proNumber={proId}
              show={this.state.showProImagesPopup}
              onClose={() => {
                this.updateModalVisibility(false);
              }}
            />
          )}
        </Suspense>

        <Slide direction="left" in={true} mountOnEnter unmountOnExit>
          <Card
            className={`${classes.card} ${this.getBillClassForLeftBorder(
              billType
            )}`}
          >
            <CardContent>
              <div className={classes.container}>
                <div className={classes.subContainerLeft}>
                  <span
                    className={classes.proId}
                    onClick={(e) => this.updateModalVisibility(true)}
                  >
                    Pro ID: {proId}
                  </span>
                  <br />
                  <span className={classes.addressHeader}>{customerName}</span>
                  <br />
                  <span className={classes.key}>Dock Worker:</span>
                  <span className={classes.value}> {dockWorkerName}</span>
                  <br />
                  <div className={classes.divKeyValueList}>
                    <div>
                      <span className={classes.keySmall}>Address :</span>
                      <span className={classes.valueSmall}> {address}</span>
                    </div>
                    <div>
                      <span className={classes.keySmall}>Weight :</span>
                      <span className={classes.valueSmall}> {weight}</span>
                    </div>
                    <div>
                      <span className={classes.keySmall}>PSE :</span>
                      <span className={classes.valueSmall}> {pse}</span>
                    </div>
                    <div>
                      <span className={classes.keySmall}>HU :</span>
                      <span className={classes.valueSmall}> {hu}</span>
                    </div>
                  </div>
                  <div className={classes.divKeyValueList}>
                    <div>
                      <span className={classes.keySmall}>
                        Actual Arrival Time :
                      </span>
                      <span className={classes.valueSmall}>
                        {" "}
                        {actualArrivalTime}
                      </span>
                    </div>
                    <div>
                      <span className={classes.keySmall}>Delivery Time :</span>
                      <span className={classes.valueSmall}>
                        {" "}
                        {deliveryWindow}
                      </span>
                    </div>
                    <div>
                      <span className={classes.keySmall}>
                        SAIA manifest No :
                      </span>
                      <span className={classes.valueSmall}>
                        {" "}
                        {manifestNumber}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={classes.subContainerRight}>
                  <div className={classes.currentLocDiv}>
                    <span className={classes.shipmentLocation}>
                      {shipmentStatus?.toLowerCase()}
                    </span>
                  </div>
                  <div className={classes.planned}>
                    <div
                      className={`${
                        classes.valueLarger
                      } ${this.getBillClassForPlannedColor(billType)} ${
                        dispatchedRouteName ? "" : classes.rightPadding
                      }`}
                    >
                      {plannedRouteName} / {dispatchedRouteName}
                    </div>
                    <div className={classes.keySmall}>
                      Planned / Dispatched Route
                    </div>
                  </div>
                  <div className={classes.planned}>
                    <div
                      className={`${
                        classes.valueLarger
                      } ${this.getBillClassForPlannedColor(billType)}  ${
                        dispatchedRouteName ? "" : classes.rightPadding
                      }`}
                    >
                      {plannedFMRT} / {dispatchedFMRT}
                    </div>
                    <div className={classes.keySmall}>
                      Planned / Dispatched Loading Zone
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </Slide>
      </Fragment>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(BillDetail);
